import useSWR from 'swr';
import API from '../api';
import { PlanHistoryEntry } from './types';

export const PLAN_HISTORY_KEY = '/plan/history';

const historyFetcher = (url: string) =>
    API.get(url).then((res) => res.data as PlanHistoryEntry[]);

export function usePlanHistory() {
    const { data, error, isLoading, mutate } = useSWR<PlanHistoryEntry[]>(
        PLAN_HISTORY_KEY,
        historyFetcher
    );

    return { history: data ?? [], error, isLoading, mutate };
}
